module.exports = __webpack_public_path__ + "static/assets/8e4a206013454c4f820e0abdef5a0146.png";